module.exports = __webpack_public_path__ + "img/cg_void_battle.33983ab9.jpg";